import * as _ from 'lodash-es'
import { Component, Vue } from 'types-vue'
import { FiltersName } from '../../enums/Filters'


@Component
export default class FiltersContainer extends Vue {

  /**
   * GETTERS
   */
  protected get nombreViaFilterName(): string {
    return FiltersName.NombreVia
  }

}
